import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null,
  );

  constructor(public authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.authService.getToken() && !request.headers.has('Authorization')) {
      request = this.addToken(request, this.authService.getToken());
    } else {
      request = this.addGeneralHeaders(request);
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 403 &&
          this.authService.isLoggedIn()
        ) {
          return this.handleAccessTokenExpiredError(request, next);
        } else {
          // this.msg.error(error?.error?.message || "Something went wrong. Please contact technical team");
          return throwError(error);
        }
      }),
    );
  }
  /* Headers without Token */
  private addGeneralHeaders(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        // 'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json',
      },
    });
  }
  /* Headers with Token */
  private addToken(request: HttpRequest<any>, token: any): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        // 'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  }
  /* Re-send the previous request after refreshing the access token */
  private handleAccessTokenExpiredError(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.access_token);
          return next.handle(this.addToken(request, token.access_token));
        }),
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        }),
      );
    }
  }
}
